<script>
    import GlobalSearchHeader from '@/components/global-search/GlobalSearchHeader.vue';
    import GlobalSeacrhFilter from '@/components/global-search/GlobalSeacrhFilter.vue';
    import GlobalSeacrhTag from '@/components/global-search/GlobalSeacrhTag.vue';
    import GlobalSeacrhComboBox from '@/components/global-search/GlobalSeacrhComboBox.vue';
    import GlobalSearchID from '@/components/global-search/GlobalSearchID.vue';

    import { promiseAll, calculatePromise } from '@/api/default.js';

    export default {
        components: {
            GlobalSearchHeader: GlobalSearchHeader,
            GlobalSeacrhFilter: GlobalSeacrhFilter,
            GlobalSeacrhTag: GlobalSeacrhTag,
            GlobalSeacrhComboBox: GlobalSeacrhComboBox,
            GlobalSearchID: GlobalSearchID,
        },
        computed: {
            showGlobalSearch() { return this.$store.getters.IS_SHOW_GLOBAL_SEARCH },
        },
        watch: {
            showGlobalSearch: {
                handler: async function(newValue, oldValue) { 
                    if (newValue === true) {
                        this.$store.commit('IS_LOAD', true);
                        await this.$store.dispatch('CHECK_ASSET_TYPES');

                        const promiseList = await calculatePromise([
                            {dispatch: 'CHECK_FILTERS_AXIOS', commit: 'FILTERS_ADD', isArray: true},
                            {dispatch: 'CHECK_TAGS_AXIOS', commit: 'TAGS', isArray: false},
                            {dispatch: 'CHECK_GAMES_AXIOS', commit: 'GAMES', isArray: false},
                            {dispatch: 'CHECK_PROVIDER_AXIOS', commit: 'PROVIDERS', isArray: false}
                        ]);
                        await promiseAll(promiseList);
                        await this.defaulValue();
                        this.$store.commit('IS_LOAD', false);
                    }
                }
            }
        },
        methods: {
            async defaulValue() {
                if (this.$store.getters.CURRENT_ASSET_TYPE == null) {
                    this.$store.commit('CURRENT_ASSET_TYPE', this.$store.getters.ASSET_TYPE_IMAGES);
                }
                if (this.$store.getters.CURRENT_GAME == null) {
                    this.$store.commit('CURRENT_GAME', this.$store.getters.DEFAULT_GAME);
                }
                if (this.$store.getters.CURRENT_PROVIDER == null) {
                    this.$store.commit('CURRENT_PROVIDER', this.$store.getters.DEFAULT_PROVIDER);
                }
                if (this.$store.getters.CURRENT_FILE_STATUS == null) {
                    this.$store.commit('CURRENT_FILE_STATUS', this.$store.getters.DEFAULT_FILE_STATUS);
                }
                if (this.$store.getters.CURRENT_ADDITIONAL_STATUS == null) {
                    this.$store.commit('CURRENT_ADDITIONAL_STATUS', this.$store.getters.DEFAULT_ADDITIONAL_STATUS);
                }
            },
        }
    }
</script>


<template>
    <div
        class="left_additional_container"
        v-if="showGlobalSearch"
    >
        <GlobalSearchHeader />
        <hr class="hr_light_98">
        <GlobalSeacrhComboBox />
        <hr class="hr_light_98">
        <GlobalSearchID />
        <hr class="hr_light_98">
        <GlobalSeacrhFilter />
        <hr class="hr_light_98">
        <GlobalSeacrhTag />
    </div>
</template>